export default {"src":"/_next/static/media/bupa.d842e05e.svg","height":35,"width":133,"blurWidth":0,"blurHeight":0};